const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M.555894 6.06591C.200583 6.41256 0 6.8896 0 7.38795v5.27195C0 13.6761.817563 14.5 1.82609 14.5h.73913c1.10457 0 2-.8954 2-2V9.89964C4.56522 8.5446 5.65531 7.44612 7 7.44612S9.43478 8.5446 9.43478 9.89964V12.5c0 1.1046.89542 2 2.00002 2h.7391C13.1824 14.5 14 13.6761 14 12.6599V7.38795c0-.49835-.2006-.97539-.5559-1.32204L8.27019 1.0181c-.70806-.690801-1.83233-.690801-2.54038 0L.555894 6.06591z" fill="currentColor"/>
    </svg>
  )
}

export default HomeIcon
